import { createContext, useContext, useState, useEffect } from "react";

const WishlistContext = createContext();

export const WishlistProvider = ({ children }) => {
  // Load wishlist from localStorage if available
  const [wishlist, setWishlist] = useState(() => {
    const saved = localStorage.getItem("wishlist");
    return saved ? JSON.parse(saved) : [];
  });

  // Save wishlist to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem("wishlist", JSON.stringify(wishlist));
  }, [wishlist]);

  const removeFromWishlist = (product) => {
    setWishlist((prev) =>
      prev.filter((item) => item._id !== product._id)
    );
  };

 const toggleWishlist = (product) => {
  setWishlist((prev) => {
    const exists = prev.find((item) => item._id === product._id);

    if (exists) {
      return prev.filter((item) => item._id !== product._id);
    } else {
      // Only store necessary info in wishlist
      return [
        ...prev,
        {
          _id: product._id,
          name: product.name,
          price: product.price,
          image: product.mainImage || product.images?.[0] || "",
        },
      ];
    }
  });
};

  const isInWishlist = (id) => {
    return wishlist.some((item) => item._id === id);
  };

  return (
    <WishlistContext.Provider
      value={{ wishlist, toggleWishlist, isInWishlist, removeFromWishlist }}
    >
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlist = () => useContext(WishlistContext);